// prototype/admin/src/85-account.js FAQ, unchanged: [question EN, AR, answer EN, AR].
export const FAQ: [string, string, string, string][] = [
  [
    "Why can't a receipt be edited?",
    "لماذا لا يمكن تعديل السند؟",
    "A receipt is proof of payment the customer already has. Changing it would make two different versions. Void it (the number stays used) and issue a new one.",
    "السند إثبات دفع لدى العميل. تعديله يخلق نسختين. ألغه (يبقى الرقم مستخدماً) وأصدر جديداً."
  ],
  [
    "When can a receipt not be voided?",
    "متى لا يمكن إلغاء السند؟",
    "Once any of its money reached the bank: a cheque deposited or cleared, cash deposited, or a transfer verified. Refund the customer and record it instead.",
    "بعد وصول أي من أمواله للبنك. رد المبلغ للعميل وسجله بدلاً من ذلك."
  ],
  [
    "How does a handover work?",
    "كيف يعمل التسليم؟",
    "The collector picks who they are handing to on the phone. That person counts the cash and ticks the cheques, here or in the app. Until then, the money shows as in transit.",
    "يختار المحصل المستلم في الهاتف. يعد المستلم النقد ويؤشر على الشيكات. حتى ذلك تظهر الأموال قيد التسليم."
  ],
  [
    "What happens when a cheque bounces?",
    "ماذا يحدث عند ارتداد شيك؟",
    "Finance marks it bounced with the bank's reason. The collector and finance are told. Then record a replacement, deposit it again, message the customer, or mark a legal case.",
    "تحدده المالية كمرتجع مع سبب البنك. يُبلغ المحصل والمالية. ثم سجل البديل أو أعد الإيداع أو راسل العميل."
  ],
  [
    "Who pays for a seat?",
    "من يحتسب كمقعد؟",
    "Every active person. Issuer seats can issue receipts; office seats (finance, admin, auditors) cannot and cost less. Invitations are free until accepted.",
    "كل شخص نشط. مقاعد المُصدر تصدر السندات، والمكتبية أرخص. الدعوات مجانية حتى القبول."
  ],
  [
    "Can collectors work without signal?",
    "هل يعمل المحصلون دون إشارة؟",
    "Yes, if your rules allow it. The phone keeps the receipt and gets its number when it reconnects, within the limit you set.",
    "نعم إن سمحت القواعد. يحفظ الهاتف السند ويحصل على رقمه عند الاتصال."
  ],
  [
    "Where is our data stored?",
    "أين تحفظ بياناتنا؟",
    "In Frankfurt (EU), encrypted, backed up daily. AI requests go encrypted to Anthropic and are never used for training.",
    "في فرانكفورت مشفرة مع نسخ يومية. طلبات الذكاء تذهب مشفرة إلى Anthropic ولا تستخدم للتدريب."
  ]
];
